/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
// import classes from './inputPhone.module.css'
import TextField from "@mui/material/TextField";

const addHyphens = (e) => {
  // var key = e.charCode || e.keyCode || 0;
  // let eleVal = e.target.value;
  // if (key !== 8 && key !== 9) {
  //     if (eleVal.length === 3) {
  //         e.target.value = eleVal + '-';
  //     }
  //     if (eleVal.length === 7) {
  //         e.target.value = eleVal + '-';
  //     }
  // }
};

const allowOnlyNumeric = (e) => {
  // if (e.which < 48 || e.which > 57 || e.target.value.length > 11) {
  if (e.which < 48 || e.which > 57) {
    e.preventDefault();
  }
};

const Input = (props) => {
  return (
    // <div className={[classes.mainDiv, props.divClass].join(' ')}>
    //     {props.label ?
    //         <label
    //             htmlFor={props.id}
    //             className={[classes.labelClass, props.labelClass].join(' ')}
    //         >
    //             {props.label}
    //         </label>
    //         : null
    //     }
    //     <input
    //         type="tel"
    //         pattern="[0-9]{3}-[0-9]{2}-[0-9]"
    //         id={props.id}
    //         disabled={props.disabled}
    //         name={props.name}
    //         value={props.value}
    //         onChange={props.onChange}
    //         placeholder={props.placeholder + " (Format: 123-456-1234)"}
    //         className={[classes.inputClass, props.inputClass].join(' ')}
    //         {...props.inputProps}
    //         onKeyDown={(e) => {
    //             addHyphens(e)
    //         }}
    //         onKeyPress={(e) => {
    //             allowOnlyNumeric(e)
    //         }}
    //     />
    // </div>
    <TextField
      type="tel"
      // pattern="[0-9]{3}-[0-9]{2}-[0-9]"
      id={props.id}
      disabled={props.disabled}
      error={props.error}
      helperText={props.helperText}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      label={props.placeholder}
      // label={props.placeholder + " (Format: 123-456-1234)"}
      className={props.className}
      {...props.inputProps}
      size={props.size ? props.size : "small"}
      variant={props.variant ? props.variant : "outlined"}
      style={props.style}
      onKeyDown={(e) => {
        addHyphens(e);
      }}
      onKeyPress={(e) => {
        allowOnlyNumeric(e);
      }}
    />
  );
};

export default Input;
